<template>
    <v-simple-table fixed-header height="300px" class="data-table">
        <template v-slot:default>
            <thead>
                <tr>
                <th class="text-left">{{ $store.getters.t('Name') }}</th>
                <th class="text-left">{{ $store.getters.t('Type') }}</th>
                <th class="text-left">{{ $store.getters.t('Size') }}</th>
                <th>{{ $store.getters.t('Progress') }}</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="file in desserts" :key="file.id">
                    <td><div style="width: 250px;">{{ file.filename }}</div></td>
                    <td>{{ file.type }}</td>
                    <td><div style="width: 70px;">{{ formatBytesToMB(file.size) }}</div></td>
                    <td>
                        <div v-if="file.status === 'pending'" style="width: 145px;">
                            <!-- 업로드 대기 상태 -->
                            <StateChips :chipText="$store.getters.t('대기 중')" ChipsColor="#eee" chipTextColor="#006CEA" />
                        </div>
                         <div  v-else-if="file.status === 'ready'" style="width: 145px;">
                            <!-- 젤 처음 상태 -->
                            <StateChips :chipText="$store.getters.t('업로드 대기 중')" ChipsColor="#eee" chipTextColor="#006CEA" />
                        </div>
                        <div v-else-if="file.status === 'waitingToResume'" style="width: 145px;">
                            <!-- 재개 대기 상태 -->
                            <StateChips :chipText="$store.getters.t('대기 중')" ChipsColor="#eee" chipTextColor="#006CEA" />
                        </div>
                        <div v-else-if="file.status === 'resumed'" style="width: 145px;">
                            <!-- 재개 대기 상태 -->
                            <StateChips :chipText="$store.getters.t('대기 중')" ChipsColor="#eee" chipTextColor="#006CEA" />
                        </div>
                        <!-- <div v-else-if="file.status === 'uploading' || file.status === 'resumed'" style="display: flex; justify-content: space-between;width: 100px;"> -->
                        <div v-else-if="file.status === 'uploading'" style="display: flex; justify-content: space-between; width: 145px;">
                            <!-- 업로드 진행 중 -->
                            <v-progress-linear :value="file.progress" color="#006CEA" height="8" class="custom-progress-bar" style="margin-top: 7px;margin-right: 8px;border-radius: 10px;"></v-progress-linear>
                            <strong style="color: #777;">{{ file.progress }}%</strong>
                        </div>
                        <div v-else-if="file.status === 'progressing'" style="width:145px">
                            <v-progress-circular indeterminate color="primary" :size="14"
                                :width="1.5"></v-progress-circular>
                        </div>
                        <div v-else-if="file.status === 'completed'" style="width:145px">
                            <!-- 업로드 완료 -->
                            <!-- <v-icon class="mr-1" color="primary" style="font-size: 20px;">mdi-check</v-icon>
                            100% 업로드 완료 -->
                            <strong class="statue_success" style="font-size: 12px;">
                                <v-icon class="mdi mdi-check-circle mr-1" color="#006CEA" style="font-size: 20px;" />{{ $store.getters.t('업로드 완료') }}
                            </strong>
                        </div>
                        <div v-else-if="file.status === 'failed'" style="width:145px;">
                            <strong class="statue_error" style="font-size: 12px;">
                                <v-icon class="mdi mdi-alert-circle mr-1" color="error" style="font-size: 20px;" />{{  $store.getters.t('업로드 실패') }}
                            </strong>
                        </div>
                        <div v-else-if="file.status === 'overlimit'" style="width:145px;">
                            <strong class="statue_error" style="font-size: 12px;">
                                <v-icon class="mdi mdi-alert-circle mr-1" color="error" style="font-size: 20px;" />{{  $store.getters.t('크기 제한 초과') }}
                            </strong>
                        </div>

                    </td>
                    <td class="pa-0">
                        <div>
                            <!-- <v-btn icon small @click="removeFile(file.id)"
                            v-if="file.status === 'pending' || file.status === 'completed' || file.status === 'failed' || file.status === 'overlimit' || file.status === 'resumed'"> -->
                            <v-btn icon small @click="removeFile(file.id)"
                            v-if="file.status === 'pending' || file.status === 'completed' || file.status === 'failed' || file.status === 'overlimit' || file.status == 'ready'">
                           <v-icon>mdi-close</v-icon>
                        </v-btn>
                        </div>
                        
                    </td>
                </tr>
            </tbody>
        </template>
    </v-simple-table>
</template>


<!-- <tr v-for="(item, index) in desserts" :key="item.name">
    <td>{{ item.name }}</td>
    <td>{{ item.type }}
    </td>
    <td>
        circular progress
        <v-progress-circular indeterminate color="primary" :size="14"
            :width="1.5"></v-progress-circular>
        Processing 상태
        <strong class="ml-2" style="font-size: 12px;">Processing</strong>
        업로드 완료 상태
        <strong class="ml-2" style="font-size: 12px;"><v-icon class="mr-1" color="primary" style="font-size: 20px;">mdi-check</v-icon>100% 업로드 완료</strong>
    </td>
    line progress
    <td style="width: 150px;" class="progress_text">
        <v-progress-linear v-model="power" color="#555" height="8"></v-progress-linear>
        <strong style="margin-left: 5px;">10%</strong>
    </td>
</tr> -->

<script>
import { mapActions } from 'vuex';
import StateChips from '../ui/chips/StateChips.vue';

export default {
    components: {
        StateChips,
    },
    props: {
        files: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        desserts() {
            // console.log("files => ", this.files)
            return this.files.map(file => ({
                ...file,
                filename: this.formatFilename(file.name),
                type: this.formatFileType(file),
                // size: `${file.size} MB`,
                // size: this.formatBytesToMB(file.size)
                size: file.size
            }));
        },
    },
    methods: {
        ...mapActions('upload', ['removeUploadedFile']),
        removeFile(fileId) {
            this.removeUploadedFile(fileId);
        },
        formatFileType(file) {
            const extension = file.name.split('.').pop().toLowerCase();

            switch (extension) {
                case 'mov':
                    return 'MOV';
                case 'mp4':
                    return 'MP4';
                default:
                    return 'Unknown';
            }
        },
        formatFilename(filename) {
            const nameParts = filename.split('.');
            if (nameParts.length > 1) {
                return nameParts.slice(0, -1).join('.');
            } else {
                return filename;
            }
        },
        formatBytesToMB(bytes){
            if (bytes === 0) return '0 MB';
            const mb = bytes / (1024 * 1024);
            return `${mb.toFixed(2)} MB`;
        },
        checkFileSize(size){
            const maxSizeInBytes = 10 * 1024 * 1024 * 1024; // 10GB
            if (size > maxSizeInBytes) {
                return false;
            }
            return true;
        },
    },
    watch: {
        files(newFiles) {
            // console.log('Files updated:', newFiles);
        }
    }
};
</script>

<style scoped>
.progress_text {
    display: flex;
    align-items: center;
}

.statue_error{
    background:rgb(255, 228, 228);
    padding: 6px 10px 6px 10px;
    border-radius: 5px;
    color: rgb(212, 67, 67);
}
.statue_success{
    background:rgb(234, 240, 255);
    padding: 6px 10px 6px 10px;
    border-radius: 5px;
    color: #006CEA;
}

.custom-progress-bar {
  background: none; /* 기본 배경을 제거 */
}

.custom-progress-bar .v-progress-linear__bar {
  background: linear-gradient(90deg, #ff7e5f, #feb47b) !important; /* 그라데이션 색상 설정 */
}
</style>
